type AppEnv = 'development' | 'qa' | 'uat' | 'production';
type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface AppConfig {
  appEnv: AppEnv;
  appTitle: string;
  apiBaseUrl: string;
  enableMocks: boolean;
  logLevel: LogLevel;
  isDev: boolean;
  isQa: boolean;
  isUat: boolean;
  isProd: boolean;
}

function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) throw new Error(`Missing required env variable: ${key}`);
  return value as string;
}

function parseAppEnv(raw: string): AppEnv {
  const valid: AppEnv[] = ['development', 'qa', 'uat', 'production'];
  if (!valid.includes(raw as AppEnv)) {
    throw new Error(`VITE_APP_ENV must be one of ${valid.join(', ')}, got "${raw}"`);
  }
  return raw as AppEnv;
}

function parseLogLevel(raw: string): LogLevel {
  const valid: LogLevel[] = ['debug', 'info', 'warn', 'error'];
  if (!valid.includes(raw as LogLevel)) {
    throw new Error(`VITE_LOG_LEVEL must be one of ${valid.join(', ')}, got "${raw}"`);
  }
  return raw as LogLevel;
}

const appEnv = parseAppEnv(requireEnv('VITE_APP_ENV'));

export const config: AppConfig = {
  appEnv,
  appTitle: requireEnv('VITE_APP_TITLE'),
  apiBaseUrl: requireEnv('VITE_API_BASE_URL'),
  enableMocks: import.meta.env['VITE_ENABLE_MOCKS'] === 'true',
  logLevel: parseLogLevel(requireEnv('VITE_LOG_LEVEL')),
  isDev: appEnv === 'development',
  isQa: appEnv === 'qa',
  isUat: appEnv === 'uat',
  isProd: appEnv === 'production',
};
